export default "__VITE_ASSET__b5b90c09__"